module.exports = __webpack_public_path__ + "static/media/6_6.129ba215.png";